import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "gatsby";

const USPWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: ${({ theme }) => theme.colors.uspBackground};
  border-bottom: 1px solid ${({ theme }) => theme.colors.uspBorderBottom};
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
  @media (max-width: 1480px) {
    height: 70px;
  }
`;

const InnerWrapper = styled.div`
  max-width: 1920px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  .left {
    justify-content: flex-start;
    @media (max-width: 1920px) {
      margin: 0 0 0 1.7rem;
    }
  }
  .right {
    justify-content: flex-end;
    @media (max-width: 1920px) {
      margin: 0 1.7rem 0 0;
    }
  }
`;

const OuterDiv = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  background-color: ${({ theme }) => theme.colors.uspBackground};
  color: ${({ theme }) => theme.colors.uspText};
  font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};

  p {
    padding: 0.4rem 0.6rem;
    margin: 0;
    font-size: 0.8rem;
    white-space: nowrap;
    width: auto;
  }

  div {
    display: flex;
    align-items: center;
    padding: 0 0.6rem;
    font-size: 0.9rem;
    white-space: nowrap;
  }
  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.uspText};

    &:hover {
      text-decoration: underline;
    }

    &:nth-child(2) {
      padding: 0 0.3rem;
    }
  }
`;

const Icon = styled(FontAwesomeIcon)`
  margin: 0 0.4rem 0 0;
  color: ${({ theme }) => theme.colors.uspIcon};
`;

const WithIcon = ({ icon, children }) =>
  icon && icon.json ? (
    <>
      <Icon style icon={icon?.json ? JSON.parse(icon?.json) : null} />
      {children}
    </>
  ) : (
    children
  );

WithIcon.propTypes = {
  icon: PropTypes.object,
  children: PropTypes.node,
};

const WithURL = ({ url, children }) =>
  url && url.match(/\.pdf$/i) ? (
    <a href={url} target="_blank" rel="noreferrer">
      {children}
    </a>
  ) : (url && url.length) > 0 ? (
    <Link to={url}>{children}</Link>
  ) : (
    children
  );

WithURL.propTypes = {
  url: PropTypes.string,
  children: PropTypes.node,
};

export default function USP({
  list,
  additional,
  paddingTop,
  paddingBottom,
  paddingRight,
  paddingLeft,
}) {
  return (
    <>
      {list?.length > 0 && (
        <USPWrapper>
          <InnerWrapper
            style={{
              paddingTop: `${paddingTop}px`,
              paddingRight: `${paddingRight}px`,
              paddingBottom: `${paddingBottom}px`,
              paddingLeft: `${paddingLeft}px`,
            }}
          >
            <OuterDiv className="left">
              {list?.map((item, index) => (
                <p key={index}>
                  <WithURL url={item?.url}>
                    <WithIcon icon={item?.icon}>{item?.text}</WithIcon>
                  </WithURL>
                </p>
              ))}
            </OuterDiv>
            <OuterDiv className="right">
              {additional?.map((item, index) => (
                <p key={index}>
                  <WithURL url={item?.url}>
                    <WithIcon icon={item?.icon}>{item?.text}</WithIcon>
                  </WithURL>
                </p>
              ))}
            </OuterDiv>
          </InnerWrapper>
        </USPWrapper>
      )}
    </>
  );
}

USP.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object),
  additional: PropTypes.arrayOf(PropTypes.object),
  paddingTop: PropTypes.string,
  paddingBottom: PropTypes.string,
  paddingRight: PropTypes.string,
  paddingLeft: PropTypes.string,
};

USP.defaultProps = {
  list: [],
  additional: [],
};
